<template>
  <div
    class="flex gap-4 items-center justify-between p-4 md:px-10 top-0 left-0 w-full z-50 leading-5"
    :class="[containerClass]"
  >
    <div
      class="flex gap-4 items-center mx-auto w-full px-5"
      :class="[contentClass]"
    >
      <div class="flex gap-4 items-center w-full">
        <div>
          <Icon
            :name="IconName.WARNING"
            :size="isMobile ? IconSize.LG : IconSize['2XL']"
          />
        </div>
        <slot></slot>
      </div>
      <button
        class="self-start md:self-auto pr-2 md:pr-0"
        @click="emit('close')"
      >
        <Icon :size="IconSize.LG" :name="IconName.CLOSE_CIRCLE" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon, IconName, IconSize } from '@exfluential/ui';
import { useIsMobile } from '~/composables/use-is-mobile';

type Props = {
  containerClass: string;
  contentClass: string;
};

const props = defineProps<Props>();
const isMobile = useIsMobile();

const emit = defineEmits<{
  (e: 'close'): void;
}>();
</script>
